import React from "react";
import "../Style/Webplatform.css";

// Inline SVG icons — no image assets needed
const icons = {
  fintech: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 10h18M5 10v9M19 10v9M9 10v9M15 10v9M3 19h18M12 3 2 8h20L12 3Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  garments: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M8 3 4 6l2 3 2-1.5V21h8V7.5L18 9l2-3-4-3-2 2h-4L8 3Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  jobportal: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="7" width="18" height="13" rx="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  it: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="4" width="18" height="12" rx="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 21h8M12 16v5M8 10l2 2-2 2M13 14h3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  automotive: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M5 11 6.5 6h11L19 11M3 11h18v5H3zM5 16v2M19 16v2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="7.5" cy="16" r="1.5" />
      <circle cx="16.5" cy="16" r="1.5" />
    </svg>
  ),
  ecommerce: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="9" cy="20" r="1.2" />
      <circle cx="18" cy="20" r="1.2" />
      <path d="M2 3h2l2.2 12.2a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6L21 7H6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  entertainment: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="12" r="9" />
      <path d="M10 9v6l5-3-5-3Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  b2b: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 21V10l6-4 6 4v11M9 21v-6h6v6M15 10l6-4v15h-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const data = [
  { icon: "fintech", title: "FinTech", desc: "Secure fintech websites with payment gateways, transaction systems, and strong data security." },
  { icon: "garments", title: "Garments", desc: "Modern websites for fashion and garment brands to showcase collections and manage bulk orders." },
  { icon: "jobportal", title: "Job Portal", desc: "Smart job portal platforms with job listings, candidate profiles, and recruitment management." },
  { icon: "it", title: "IT", desc: "Professional IT websites to highlight services, portfolios, and technology expertise." },
  { icon: "automotive", title: "Automotive", desc: "Feature-rich automotive websites to showcase vehicles, specifications, and booking options." },
  { icon: "ecommerce", title: "E-Commerce", desc: "High-performance online stores with product catalogs, secure payments, and order management." },
  { icon: "entertainment", title: "Entertainment", desc: "Engaging platforms for media, events, and content streaming experiences." },
  { icon: "b2b", title: "B2B", desc: "Powerful B2B platforms to connect businesses, manage bulk orders, and generate leads." },
];

function Webplatform() {
  return (
    <section className="webplatform">
      <h2 className="webplatform-title">
        Web Development Services &amp; Various Platforms
      </h2>

      <div className="webplatform-grid">
        {data.map((item, index) => (
          <div className="webplatform-card" key={index}>
            <div className="webplatform-icon-wrapper">{icons[item.icon]}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Webplatform;